module.exports = __webpack_public_path__ + "img/26.67700914.png";